import { AbstractClone } from "../../abstract/clone.abstract";
import { Injectable, Injector } from "@angular/core";
import { WidgetsAbstract } from "../../abstract/widgets/widgets.abstract";
import { CloneService } from "./clone.service";
import { WidgetsSectionModel } from "src/app/models/widgets/widgets-section.model";
import { WidgetsFormModel } from "src/app/models/widgets/widgets-form.model";
import { WidgetsContainerAbstract } from "src/app/abstract/widgets/widgets-container.abstract";
import { WidgetsRowModel } from "src/app/models/widgets/widgets-row.model";
import { WidgetsArrayModel } from "src/app/models/widgets/widgets-array.model";
import { WidgetsColumnModel } from "src/app/models/widgets/widgets-column.model";
import { WidgetsTypeEnum } from "src/app/enums/widgets/widgets-type.enum";
import { WidgetsFieldModel } from "src/app/models/widgets/widgets-field.model";
import { WidgetsRadioModel } from "src/app/models/widgets/widgets-radio.model";
import { WidgetsCheckboxModel } from "src/app/models/widgets/widgets-checkbox.model";
import { WidgetsTimeRangeModel } from "src/app/models/widgets/widgets-time-range.model";
import { WidgetsInputModel } from "src/app/models/widgets/widgets-input.model";
import { WidgetsService } from "../widgets/widgets.service";
import { WidgetRelatedInputComponent } from "src/app/components/widgets/widget-related-input/widget-related-input.component";
import { WidgetsRelatedinputModel } from "src/app/models/widgets/widgets-related-input.model";
@Injectable({
  providedIn: 'root'
})
export class ClonePrimitiveService extends AbstractClone {

  constructor(private injector: Injector,
    private widgetsService: WidgetsService) {
    super();
  }

  cloneFromJS(origWidget: any,
    destWidget: WidgetsAbstract,
    isDragNDrop: boolean,
    isInsideQuestion: boolean,
    parentId: string | undefined) {
      let orgWidget;
      let newInput;
    
      if (origWidget.widgetType == WidgetsTypeEnum.FIELD) {
        orgWidget = origWidget as WidgetsFieldModel;
        newInput = new WidgetsFieldModel();
        newInput.cloneFrom(orgWidget);
      } else if (origWidget.widgetType == WidgetsTypeEnum.RADIO) {
        orgWidget = origWidget as WidgetsRadioModel;
        newInput = new WidgetsRadioModel();
        newInput.cloneFrom(orgWidget);
      } else if(origWidget.widgetType == WidgetsTypeEnum.CHECKBOX){
        orgWidget = origWidget as WidgetsCheckboxModel;
        newInput = new WidgetsCheckboxModel();
        newInput.cloneFrom(orgWidget);
      } else if (origWidget.widgetType == WidgetsTypeEnum.TIME_RANGE) {
        orgWidget = origWidget as WidgetsTimeRangeModel;
        newInput = new WidgetsTimeRangeModel();
        newInput.cloneFrom(orgWidget);            
      } else if (origWidget.widgetType == WidgetsTypeEnum.INPUT) {
        orgWidget = origWidget as WidgetsInputModel;
        newInput = new WidgetsInputModel();
        newInput.cloneFrom(orgWidget);
      }else if (origWidget.widgetType == WidgetsTypeEnum.ORDINAL_IN_SET) {
        orgWidget = origWidget as WidgetsRelatedinputModel;
        newInput = new WidgetsRelatedinputModel();
        newInput.cloneFrom(orgWidget);
      }
      newInput.parentId = parentId;

      // Only autoincrement key name with sequence IF NOT inside a CUSTOM WIDGET
      if (isDragNDrop && !isInsideQuestion) {
        // Change key
        const names: string[] = this.widgetsService.getAllFieldsOfType(orgWidget.type);
        if (names.length > 0)
          newInput.key = newInput.key + names.length;
      }

      const container = destWidget as WidgetsContainerAbstract;
      container.children.push(newInput);

      // Clone validations (input fields children are validations)
      if (orgWidget.children) {
        // Retrieve from injector to avoid circular dependency
        const widgetsCloneService = this.injector.get(CloneService);

        orgWidget.children.forEach(validationWidget => {
          widgetsCloneService.cloneFromJS(validationWidget, newInput, isDragNDrop, isInsideQuestion, '');
        });
      }
  }
}
